// ✅ Countries data with prioritized order
export const Countries = [
  // 🥇 Prioritized countries at the top
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    flag: "/assets/images/country-flags/kw.svg",
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    flag: "/assets/images/country-flags/sa.svg",
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    flag: "/assets/images/country-flags/pk.svg",
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    flag: "/assets/images/country-flags/bh.svg",
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    flag: "/assets/images/country-flags/qa.svg",
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE",
    flag: "/assets/images/country-flags/ae.svg",
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    flag: "/assets/images/country-flags/om.svg",
  },
];

// ✅ Regex map per country
export const phonePatterns = {
  PK: /^(0?3)\d{9}$/,            // 03XXXXXXXXX or 3XXXXXXXXX (11 or 10 digits)
  KW: /^\d{8}$/,                // 8 digits (e.g. 50000000)
  SA: /^\d{9}$/,                // 9 digits (e.g. 512345678)
  AE: /^\d{9}$/,                // 9 digits (e.g. 501234567)
  BH: /^\d{8}$/,                // 8 digits (e.g. 36000000)
  QA: /^\d{8}$/,                // 8 digits (e.g. 33123456)
  OM: /^\d{8}$/,                // 8 digits (e.g. 92123456)
};

// ✅ Get max digits based on country
export const getMaxDigits = (countryCode) => {
  switch (countryCode) {
    case "PK":
      return 11; // because users might include leading 0
    case "KW":
      return 11 ; // because users might include leading 0    
    case "BH":
    case "QA":
    case "OM":
      return 8;
    case "SA":
    case "AE":
      return 9;
    default:
      return 10;
  }
};

const kuwaitiMobileRegex = /^(?:\+965)?([569]\d{7})$/;


// ✅ Validate phone number for specific country
export const  validatePhoneNumber = (phoneNumber, countryCode) => {
  if (!phoneNumber || phoneNumber.length === 0) {
    return { isValid: true, error: "" }; // Empty is valid (not required yet)
  }

  const regex = phonePatterns[countryCode];
  if (!regex) {
    return { isValid: true, error: "" }; // No validation for unknown countries
  }

  if (!kuwaitiMobileRegex.test(phoneNumber)) {
    const country = Countries.find(c => c.code === countryCode);
    return { 
      isValid: false, 
      error: `Invalid ${country?.name || countryCode} phone number format` 
    };
  }

  return { isValid: true, error: "" };
};

// ✅ Get mask pattern based on country
export const getMaskPattern = (countryCode) => {
  switch (countryCode) {
    case "PK":
      return "99999999999"; // 11 digits
    case "KW":
    case "BH":
    case "QA":
    case "OM":
      return "9999999999"; // 8 digits
    case "SA":
    case "AE":
      return "999999999"; // 9 digits
    default:
      return "9999999999"; // 10 digits default
  }
};
